import { Base, createApp } from '@studiometa/js-toolkit';
import { Figure } from '@studiometa/ui';
import Projects from './molecules/Projects.js';
import Sidebar from './organisms/Sidebar.js';
import SidebarRight from './molecules/SidebarRight.js';
import LargeText from './molecules/LargeText.js';
import Texts from './molecules/Texts.js';
import { isDev } from './config.js';
import useTaxi from './utils/taxi/index.js';
import useLenis from './utils/lenis/index.js';
import Cursor from './atoms/Cursor.js';
import Splash from './atoms/Splash.js';
import ImageZoom from './molecules/ImageZoom.js';
import AboutAnimation from './molecules/AboutAnimation.js';

/**
 * Main App class.
 */
class App extends Base {
  /**
   * App config.
   * @returns {Object}
   */
  static config = {
    log: isDev(),
    name: 'App',
    refs: ['transitionOverlay'],
    components: {
      Figure,
      Projects,
      Sidebar,
      SidebarRight,
      LargeText,
      Texts,
      Cursor,
      Splash,
      ImageZoom,
      AboutAnimation,
    },
  };

  /**
   * Log a nice message when app is ready.
   *
   * @returns {void}
   */
  mounted() {
    this.windowWidth = window.innerWidth / 6;

    // Highway
    window.taxi = useTaxi(this);
    window.lenis = useLenis();

    requestAnimationFrame(this.requestLenis.bind(this));
  }

  /**
   * Get scroll smoothing !
   * @param  {string} time
   * @returns {void}
   */
  requestLenis(time) {
    window.lenis.raf(time);
    requestAnimationFrame(this.requestLenis.bind(this));
  }

  /**
   * List changing layout
   * @param  {string} template
   * @param  {string} data
   * @returns {void}
   */
  onSidebarRightChangeList(template, data) {
    this.$children.Projects[0].changeLayout(template, data);
  }

  /**
   * Update component
   * @returns {void}
   */
  onProjectsUpdateApp() {
    window.taxi.updateCache();
    window.taxi.clearCache();
    this.$update();
  }

  /**
   * Update component
   * @returns {void}
   * @param {object} target
   */
  onTextsTextTransitionFinished(target) {
    const currentText = this.$children.LargeText.find((text) => text.$el === target);
    setTimeout(() => {
      currentText.animate = false;
    }, 1000);
  }
}

export default createApp(App, document.body);
